@if (isDialog) {
  <div mat-dialog-header>
    <h1
      class="is-dialog"
      [class.complete]="loadingVal === 100"
      [class.failure]="loadingVal === -1"
    >
      {{ headline }}
    </h1>
  </div>
  <div mat-dialog-content class="dialog-container col-12">
    <div class="inner row col-12 mb-3" [innerHTML]="content"></div>
    <mat-progress-bar
      mode="determinate"
      [value]="loadingVal"
      [color]="progressColor()"
    />
  </div>
} @else {
  @if (headline) {
    <div>
      <h2
        class="not-dialog"
        [class.complete]="loadingVal === 100"
        [class.failure]="loadingVal === -1"
      >
        {{ headline }}
      </h2>
    </div>
  }
  @if (content) {
    <div>
      <div class="inner col-12 mb-3">{{ content }}</div>
      <mat-progress-bar
        mode="determinate"
        [value]="loadingVal"
        [color]="progressColor()"
      />
    </div>
  }
}
